export const checkBox_style = {
  checkSx: {
    p: 0,
    pr: 1,
  },
};
